import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../components/text_display/Text_display.css";
import { businessSchemaDE, businessSchemaEN } from "../schema";

const PrivacyNotice = () => {
  const { i18n } = useTranslation();
  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  const handleLinkKeyDown = (e, href) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      window.location.href = href;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {i18n.language === "en"
            ? "Privacy Notice - Violin Maker Jacobi"
            : "Datenschutzerklärung - Geigenbau Jacobi"}
        </title>
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify(currentSchema)}
      </script>
      <div className="privacy-notice-container">
        <h1 className="privacy-header focus-highlight" tabIndex={0}>
          Datenschutzerklärung
        </h1>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Die Nutzung unserer Website ist in der Regel
          ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten
          personenbezogene Daten (beispielsweise Name, Anschrift oder
          E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets
          auf freiwilliger Basis. Eine Übermittlung an Dienstleister oder andere
          Empfänger erfolgt nur auf einer gesetzlichen Grundlage und zu den in
          dieser Datenschutzerklärung beschriebenen Zwecken. Wir weisen darauf hin, dass
          die Datenübertragung im Internet (z.B. bei der Kommunikation per
          E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der
          Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          1. Datenschutz auf einen Blick
        </h2>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Allgemeine Hinweise
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können. Ausführliche Informationen zum
          Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Datenerfassung auf dieser Website
        </h3>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
          „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung
          entnehmen.
        </p>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Wie erfassen wir Ihre Daten?
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein
          Kontaktformular eingeben. Andere Daten werden automatisch oder nach
          Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme
          erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser,
          Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser
          Daten erfolgt automatisch, sobald Sie diese Website betreten.
        </p>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Wofür nutzen wir Ihre Daten?
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
          der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
          geschlossen oder angebahnt werden können, werden die übermittelten
          Daten auch für Vertragsangebote, Bestellungen oder sonstige
          Auftragsanfragen verarbeitet.
        </p>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Welche Rechte haben Sie bezüglich Ihrer Daten?
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
          dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
          Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
          unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Hierzu sowie
          zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an
          uns wenden.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          2. Hosting
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          All-Inkl
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Anbieter ist die ALL-INKL.COM - Neue Medien Münnich, Inh. René
          Münnich, Hauptstraße 68, 02742 Friedersdorf (nachfolgend All-Inkl).
          Details entnehmen Sie der Datenschutzerklärung von All-Inkl:
          https://all-inkl.com/datenschutzinformationen/. Die Verwendung von
          All-Inkl erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir
          haben ein berechtigtes Interesse an einer möglichst zuverlässigen
          Darstellung unserer Website. Sofern eine entsprechende Einwilligung
          abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage
          von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
          Einwilligung die Speicherung von Cookies oder den Zugriff auf
          Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im
          Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Auftragsverarbeitung
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
          des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
          einen datenschutzrechtlich vorgeschriebenen Vertrag, der
          gewährleistet, dass dieser die personenbezogenen Daten unserer
          Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
          DSGVO verarbeitet.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          3. Allgemeine Hinweise und Pflichtinformationen
        </h2>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Datenschutz
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Wenn Sie diese Website benutzen, werden
          verschiedene personenbezogene Daten erhoben. Personenbezogene Daten
          sind Daten, mit denen Sie persönlich identifiziert werden können. Die
          vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
          und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck
          das geschieht. Wir weisen darauf hin, dass die Datenübertragung im
          Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken
          aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
          Dritte ist nicht möglich.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Hinweis zur verantwortlichen Stelle
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist: Geigenbaumeister Andreas Jacobi Bischof-Blum-Platz 9
          65366 Geisenheim / Rheingau - Germany Telefon: 0049-(0)6722-971982
          E-Mail: kontakt@geigenbau-jacobi.de Verantwortliche Stelle ist die
          natürliche oder juristische Person, die allein oder gemeinsam mit
          anderen über die Zwecke und Mittel der Verarbeitung von
          personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
          entscheidet.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Speicherdauer
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
          bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
          ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
          zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
          wir keine anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z. B. steuer- oder
          handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
          erfolgt die Löschung nach Fortfall dieser Gründe.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf
          dieser Website
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten
          wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit.
          a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
          Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle
          einer ausdrücklichen Einwilligung in die Übertragung personenbezogener
          Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf
          Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die
          Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr
          Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt
          die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG.
          Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
          Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs.
          1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese
          zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf
          Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann
          ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs.
          1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen
          Rechtsgrundlagen wird in den folgenden Absätzen dieser
          Datenschutzerklärung informiert.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Hinweis zur Datenweitergabe in datenschutzrechtlich nicht sichere
          Drittstaaten sowie die Weitergabe an US-Unternehmen, die nicht
          DPF-zertifiziert sind
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wir verwenden unter anderem Tools von Unternehmen mit Sitz in
          datenschutzrechtlich nicht sicheren Drittstaaten sowie US-Tools, deren
          Anbieter nicht nach dem EU-US-Data Privacy Framework (DPF)
          zertifiziert sind. Wenn diese Tools aktiv sind, können Ihre
          personenbezogene Daten in diese Staaten übertragen und dort
          verarbeitet werden. Wir weisen darauf hin, dass in
          datenschutzrechtlich unsicheren Drittstaaten kein mit der EU
          vergleichbares Datenschutzniveau garantiert werden kann. Wir weisen
          darauf hin, dass die USA als sicherer Drittstaat grundsätzlich ein mit
          der EU vergleichbares Datenschutzniveau aufweisen. Eine
          Datenübertragung in die USA ist danach zulässig, wenn der Empfänger
          eine Zertifizierung unter dem „EU-US Data Privacy Framework“ (DPF)
          besitzt oder über geeignete zusätzliche Garantien verfügt.
          Informationen zu Übermittlungen an Drittstaaten einschließlich der
          Datenempfänger finden Sie in dieser Datenschutzerklärung.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Empfänger von personenbezogenen Daten
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
          externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung
          von personenbezogenen Daten an diese externen Stellen erforderlich.
          Wir geben personenbezogene Daten nur dann an externe Stellen weiter,
          wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
          gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an
          Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs.
          1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige
          Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
          Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden
          nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung
          weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
          gemeinsame Verarbeitung geschlossen.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Widerruf Ihrer Einwilligung zur Datenverarbeitung
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER
          F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
          AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
          AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
          RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
          DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
          IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
          SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
          VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN
          ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG
          ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS.
          1 DSGVO). WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM
          DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT
          WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER
          DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS
          PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT.
          WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
          ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET
          (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Beschwerderecht bei der zuständigen Aufsichtsbehörde
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht
          besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Recht auf Datenübertragbarkeit
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Auskunft, Berichtigung und Löschung
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
          Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Recht auf Einschränkung der Verarbeitung
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
          folgenden Fällen: Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
          personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit,
          um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht,
          die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
          verlangen. Wenn die Verarbeitung Ihrer personenbezogenen Daten
          unrechtmäßig geschah/geschieht, können Sie statt der Löschung die
          Einschränkung der Datenverarbeitung verlangen. Wenn wir Ihre
          personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur
          Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen
          benötigen, haben Sie das Recht, statt der Löschung die Einschränkung
          der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Wenn Sie
          einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine
          Abwägung zwischen Ihren und unseren Interessen vorgenommen werden.
          Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie
          das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
          Daten zu verlangen. Wenn Sie die Verarbeitung Ihrer personenbezogenen
          Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung
          abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung,
          Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der
          Rechte einer anderen natürlichen oder juristischen Person oder aus
          Gründen eines wichtigen öffentlichen Interesses der Europäischen Union
          oder eines Mitgliedstaats verarbeitet werden.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          4. Datenerfassung auf dieser Website
        </h2>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Kontaktformular und E-Mail-Versand über EmailJS
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wenn Sie uns über unser Kontaktformular kontaktieren, verarbeiten wir
          Ihren Namen, Ihre E-Mail-Adresse und den Inhalt Ihrer Nachricht, um
          Ihre Anfrage zu bearbeiten und gegebenenfalls Rückfragen zu beantworten.
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Für die technische Übermittlung nutzen wir EmailJS, einen Dienst der
          EmailJS Pte. Ltd. Ihre Formulareingaben werden an EmailJS übermittelt
          und anschließend über den SMTP-Dienst unseres E-Mail-Anbieters
          ALL-INKL.COM – Neue Medien Münnich, Hauptstraße 68, 02742 Friedersdorf,
          an unser Postfach kontakt@geigenbau-jacobi.de zugestellt. Dabei werden
          auch technische Verbindungs- und Versanddaten verarbeitet,
          beispielsweise die IP-Adresse und Informationen zum Versandvorgang.
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Soweit Ihre Anfrage mit einem Vertrag zusammenhängt oder zur
          Durchführung vorvertraglicher Maßnahmen erforderlich ist, erfolgt die
          Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Bei sonstigen
          Anfragen ist die Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Unser
          berechtigtes Interesse besteht in der zuverlässigen Kommunikation und
          der Bearbeitung eingehender Anfragen.
        </p>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Auftragsverarbeitung und Übermittlung in Drittländer
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          EmailJS wird zur technischen Abwicklung des Versands als
          Auftragsverarbeiter eingesetzt. Die datenschutzrechtlichen Pflichten
          sind in der von EmailJS in seine Nutzungsbedingungen einbezogenen{" "}
          <a href="https://www.emailjs.com/legal/data-protection-agreement/">
            Vereinbarung zur Auftragsverarbeitung (Data Processing Agreement)
          </a>{" "}
          beschrieben. Informationen zur Auftragsverarbeitung durch ALL-INKL.COM
          finden Sie auch im Abschnitt „Hosting“ dieser Datenschutzerklärung.
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Nach Angaben von EmailJS befindet sich die für den Dienst eingesetzte
          Infrastruktur in den USA. Daher werden personenbezogene Daten auch
          außerhalb der Europäischen Union beziehungsweise des Europäischen
          Wirtschaftsraums verarbeitet. EmailJS sieht für diese Übermittlungen
          in seiner Vereinbarung zur Auftragsverarbeitung die Verwendung der von
          der Europäischen Kommission genehmigten Standardvertragsklauseln vor.
          Weitere Informationen zu den vorgesehenen Garantien finden Sie in der
          oben verlinkten Vereinbarung. Eine Kopie der für unsere Verarbeitung
          maßgeblichen Garantien können Sie über die in dieser
          Datenschutzerklärung angegebenen Kontaktdaten anfordern.
        </p>
        <h4 className="privacy-subheader-h4 focus-highlight" tabIndex={0}>
          Speicherung und Löschung
        </h4>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          In unserer EmailJS-Konfiguration ist die Speicherung der übermittelten
          Nachrichteninhalte im Nachrichtenverlauf deaktiviert. Die Inhalte
          werden dennoch zur Durchführung des Versands verarbeitet. Die
          Deaktivierung bedeutet nicht, dass keinerlei Daten gespeichert werden:
          EmailJS verarbeitet daneben technische Metadaten und gegebenenfalls
          Sicherheitsprotokolle. Für gespeicherte Daten aktiver Konten nennt
          EmailJS grundsätzlich eine Aufbewahrungsdauer von 30 Tagen. Zur
          Aufklärung und Abwehr von Missbrauch können nach Angaben des Anbieters
          insbesondere IP-Protokolle darüber hinaus aufbewahrt werden.
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wir löschen Ihre Anfrage und die zugehörige Korrespondenz, sobald die
          Bearbeitung abgeschlossen ist und die Daten für weitere Rückfragen
          nicht mehr erforderlich sind. Soweit gesetzliche Aufbewahrungspflichten
          bestehen oder eine weitere Speicherung zur Geltendmachung, Ausübung
          oder Verteidigung von Rechtsansprüchen erforderlich ist, bewahren wir
          die hierfür erforderlichen Daten entsprechend länger auf.
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Weitere Informationen finden Sie in der{" "}
          <a href="https://www.emailjs.com/legal/privacy-policy/">
            Datenschutzerklärung von EmailJS
          </a>{" "}
          und den{" "}
          <a href="https://all-inkl.com/datenschutzinformationen/">
            Datenschutzinformationen von ALL-INKL.COM
          </a>
          . Informationen zum eingesetzten Spam-Schutz finden Sie im Abschnitt
          „Google reCAPTCHA“ dieser Datenschutzerklärung.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Server-Log-Dateien
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Der Provider der Seiten erhebt und speichert automatisch Informationen
          in so genannten Server-Log- Dateien, die Ihr Browser automatisch an
          uns übermittelt. Dies sind:
          <br />
          Browsertyp und Browserversion,
          <br />
          verwendetes Betriebssystem,
          <br />
          Referrer URL Hostname des zugreifenden Rechners,
          <br />
          Uhrzeit der Serveranfrage IP-Adresse
          <br />
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art.
          6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
          Interesse an der technisch fehlerfreien Darstellung und der
          Optimierung seiner Website – hierzu müssen die Server-Log-Files
          erfasst werden.
        </p>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Anfrage per E-Mail, Telefon oder Socialmediakanäle
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Wenn Sie uns per E-Mail, Telefon oder Socialmediakanäle kontaktieren, wird Ihre
          Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
          (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
          gespeichert und verarbeitet. Für die Verarbeitung von E-Mails nutzen
          wir den oben beschriebenen E-Mail-Anbieter ALL-INKL.COM. Eine
          Übermittlung an weitere Empfänger erfolgt nur auf einer gesetzlichen
          Grundlage. Die Verarbeitung dieser Daten erfolgt auf
          Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der
          Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
          beruht die Verarbeitung auf unserem berechtigten Interesse an der
          effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1
          lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
          sofern diese abgefragt wurde; die Einwilligung ist jederzeit
          widerrufbar. Die von Ihnen an uns per Kontaktanfragen übersandten
          Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre
          Einwilligung zur Speicherung widerrufen oder der Zweck für die
          Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung
          Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere
          gesetzliche Aufbewahrungsfristen – bleiben unberührt.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          5. Plugins und Tools
        </h2>
        <h3 className="privacy-subheader focus-highlight" tabIndex={0}>
          Datenschutzerklärung für Sketchfab 3D-Modelle
        </h3>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Beim Zugriff auf manche Teildienste unserer Website werden zusätzliche
          personenbezogene Daten verarbeitet. Dabei verarbeitete
          Datenkategorien: technische Verbindungsdaten des Serverzugriffs
          (IP-Adresse, Datum, Uhrzeit, abgefragte Seite, Browser-Informationen)
          und Daten zur Erstellung von Nutzungsstatistiken. Zweck der
          Verarbeitung: Auslieferung und Bereitstellung der Website und
          Anonymisierung und Erstellung von Statistiken. Die Rechtsgrundlage für
          die Verarbeitung: Ihre Einwilligung nach Art. 6 (1) a DSGVO, ein
          berechtigtes Interesse, das die Rechte und Freiheiten der betroffenen
          Personen überwiegt (Art. 6 (1) f DSGVO). Eine Übermittlung von Daten
          erfolgt: an den Auftragsverarbeiter Sketchfab, Inc., 440 9th Ave,
          Suite 1700, New York, NY 10001, USA. Dies kann auch eine Übermittlung
          von personenbezogenen Daten in ein Land außerhalb der Europäischen
          Union bedeuten. Die Übermittlung der Daten erfolgt auf Basis Ihrer
          Einwilligung gemäß Art. 6 Abs 1 lit a iVm Art. 49 Abs 1 lit a DSGVO.
          Sie wurden bereits vor Erteilung Ihrer Einwilligung informiert, dass
          die USA über kein den Standards der EU entsprechendes
          Datenschutzniveau verfügt. Insbesondere können US Geheimdienste auf
          Ihre Daten zugreifen, ohne dass Sie darüber informiert werden und ohne
          dass Sie dagegen rechtlich vorgehen können.
        </p>
        <h3 className="privacy-subheader">Google reCAPTCHA</h3>
        <p className="privacy-text">
          Wir nutzen „Google reCAPTCHA“ (im Folgenden „reCAPTCHA“) auf dieser
          Website. Anbieter ist die Google Ireland Limited („Google“), Gordon
          House, Barrow Street, Dublin 4, Irland. Mit reCAPTCHA soll überprüft
          werden, ob die Dateneingabe auf dieser Website (z. B. in einem
          Kontaktformular) durch einen Menschen oder durch ein automatisiertes
          Programm erfolgt. Hierzu analysiert reCAPTCHA das Verhalten des
          Websitebesuchers anhand verschiedener Merkmale. Diese Analyse beginnt
          automatisch, sobald der Websitebesucher die Website betritt. Zur
          Analyse wertet reCAPTCHA verschiedene Informationen aus (z. B.
          IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder vom
          Nutzer getätigte Mausbewegungen). Die bei der Analyse erfassten Daten
          werden an Google weitergeleitet. Die reCAPTCHA-Analysen laufen
          vollständig im Hintergrund. Websitebesucher werden nicht darauf
          hingewiesen, dass eine Analyse stattfindet. Die Speicherung und
          Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
          DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse daran,
          seine Webangebote vor missbräuchlicher automatisierter Ausspähung und
          vor SPAM zu schützen. Sofern eine entsprechende Einwilligung abgefragt
          wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art.
          6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung
          die Speicherung von Cookies oder den Zugriff auf Informationen im
          Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG
          umfasst. Die Einwilligung ist jederzeit widerrufbar. Weitere
          Informationen zu Google reCAPTCHA entnehmen Sie den
          Google-Datenschutzbestimmungen und den Google Nutzungsbedingungen
          unter folgenden Links: https://policies.google.com/privacy?hl=de und
          https://policies.google.com/terms?hl=de. Das Unternehmen verfügt über
          eine Zertifizierung nach dem „EU-US Data Privacy Framework“ (DPF). Der
          DPF ist ein Übereinkommen zwischen der Europäischen Union und den USA,
          der die Einhaltung europäischer Datenschutzstandards bei
          Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem DPF
          zertifizierte Unternehmen verpflichtet sich, diese
          Datenschutzstandards einzuhalten. Weitere Informationen hierzu
          erhalten Sie vom Anbieter unter folgendem Link:
          https://www.dataprivacyframework.gov/participant/5780.
        </p>
        <h2 className="privacy-subheader">Quelle: https://www.e-recht24.de</h2>
        {/* Add more sections with sub-headers as needed */}
      </div>
    </>
  );
};

export default PrivacyNotice;
